import api from './API'

const ACCOUNTS_URL = '/accounts'

export default {
  loadAccounts: function () {
    return api.newRequest('get', ACCOUNTS_URL)
  },
  loadAccount: function (id) {
    var url = ACCOUNTS_URL + '/' + id
    return api.newRequest('get', url)
  },
  createAccount: function (account) {
    console.log('creating account...')
    return api.newRequest('post', ACCOUNTS_URL, account)
  },
  updateAccount: function (account) {
    var url = ACCOUNTS_URL + '/' + account.id
    return api.newRequest('patch', url, account)
  },
  deleteAccount: function (id) {
    var url = ACCOUNTS_URL + '/' + id
    return api.newRequest('delete', url)
  }
}
